import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth.store';
import { authApi } from '../../lib/api';

export function Header() {
  const navigate = useNavigate();
  const { user, clearAuth } = useAuthStore();

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch {
      // Ignore errors
    }
    clearAuth();
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo / Brand */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">P</span>
              </div>
              <span className="text-xl font-semibold text-gray-900">
                PAA Pipeline
              </span>
            </Link>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link
              to="/"
              className="text-gray-600 hover:text-gray-900 font-medium"
            >
              Dashboard
            </Link>
            <Link
              to="/clients"
              className="text-gray-600 hover:text-gray-900 font-medium"
            >
              Clients
            </Link>
            <Link
              to="/workflows/new"
              className="text-gray-600 hover:text-gray-900 font-medium"
            >
              New Workflow
            </Link>
          </nav>

          {/* User Menu */}
          <div className="flex items-center space-x-4">
            {user && (
              <>
                <span className="text-sm text-gray-600">
                  {user.name || user.email}
                </span>
                <button
                  onClick={handleLogout}
                  className="text-sm text-gray-500 hover:text-gray-700"
                >
                  Sign out
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="md:hidden border-t border-gray-200">
        <nav className="flex justify-around py-2">
          <Link
            to="/"
            className="text-gray-600 hover:text-gray-900 text-sm font-medium px-3 py-2"
          >
            Dashboard
          </Link>
          <Link
            to="/clients"
            className="text-gray-600 hover:text-gray-900 text-sm font-medium px-3 py-2"
          >
            Clients
          </Link>
          <Link
            to="/workflows/new"
            className="text-gray-600 hover:text-gray-900 text-sm font-medium px-3 py-2"
          >
            New
          </Link>
        </nav>
      </div>
    </header>
  );
}
